import { createTheme, Theme } from "@mui/material";
import { getPalette, ThemeMode } from "./palette";
import { typography } from "./typography";
import { getComponents } from "./components";
import { radius } from "./tokens";

// Builds the full theme for a given mode. Kept as a function (not a static
// object) so light/dark can be swapped at runtime by ThemeModeContext.
//
// direction is "rtl" here (the previous theme said "ltr" while the app's
// actual layout was flipped via stylis-plugin-rtl at the Emotion cache
// level) — that mismatch meant MUI's own RTL-aware internals (Menu/Popper
// placement, logical-property defaults) were reasoning about the wrong
// direction. Aligning theme.direction with the real, Arabic-first layout
// is a correctness fix, not just styling.
export const getAppTheme = (mode: ThemeMode): Theme => {
  const base = createTheme({
    direction: "rtl",
    palette: getPalette(mode),
    typography,
    shape: { borderRadius: radius.md },
  });

  return createTheme(base, {
    components: getComponents(base),
  });
};

// Preserved default export for anything importing the old static theme
// shape; prefer getAppTheme(mode) via ThemeModeContext for new code.
export const MuiTheme = getAppTheme("light");
